import { action } from 'satcheljs';
import type { Module } from 'owa-workloads-module';

export const onModuleSwitch: (
    targetModule: Module,
    isWarm: boolean
) => {
    targetModule: Module;
    isWarm: boolean;
} = action(
    'onModuleSwitch',
    (
        targetModule: Module,
        isWarm: boolean
    ): {
        targetModule: Module;
        isWarm: boolean;
    } => ({
        targetModule,
        isWarm,
    })
);
